import angular from 'angular'

angular
  .module('ggs.utils')
  .factory('rootId', rootIdProvider)
  .factory('rootQs', rootQsProvider)
  .factory('rootClass', rootClassProvider)

const ROOT_CLASS = 'ggsi'
const ROOT_ID_SUFFIX = '_root'

function rootQsProvider(rootClass, rootId) {
  return `.${rootClass}#${rootId}`
}

function rootIdProvider(idPrefix) {
  return idPrefix + ROOT_ID_SUFFIX
}

function rootClassProvider() {
  return ROOT_CLASS
}
